import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import { ActorState } from "../../models/ActorState";
import { ActorMovementType } from "../../models/ActorMovementType";
import { useTranslation } from "react-i18next";
import PiSegmentedToggle, {
  PiSegmentedToggleOption,
} from "../../components/PiSegmentedToggle";

export default function ActorStateMovementToggle(props: {
  actor: ActorState;
  onChange: (movement: ActorMovementType) => void;
  disabled: boolean;
  variant?: "default" | "compact";
}) {
  const { actor, onChange, disabled, variant = "default" } = { ...props };
  const { t } = useTranslation();

  const options: PiSegmentedToggleOption<ActorMovementType>[] = [
    {
      testId: "movement-instant",
      label:
        variant === "compact" ? (
          <BoltOutlinedIcon fontSize="inherit" />
        ) : (
          <>
            <BoltOutlinedIcon fontSize="inherit" />
            <span>Instant</span>
          </>
        ),
      value: ActorMovementType.Instant,
    },
    {
      testId: "movement-walk",
      label:
        variant === "compact" ? (
          <DirectionsRunOutlinedIcon fontSize="inherit" />
        ) : (
          <>
            <DirectionsRunOutlinedIcon fontSize="inherit" />
            <span>Walk</span>
          </>
        ),
      value: ActorMovementType.Walk,
    },
  ];

  return (
    <div className={"flex flex-col gap-[8px]"}>
      <div className={"text-creator-text text-[14px] font-medium"}>
        {t("movement")}
      </div>
      <PiSegmentedToggle
        ariaLabel="movement-toggle"
        disabled={disabled}
        fullWidth
        layoutId={`actorstate-movement-toggle-${variant}`}
        options={options}
        value={actor.movement}
        onChange={onChange}
      />
    </div>
  );
}
